import { IGameGift } from "../type"
import json from "./json/gift.json"
import ImageKaltsB from "../../../assets/img/game/gift/kalts-b.png"
import ImageKaltsL from "../../../assets/img/game/gift/kalts-l.png"
import ImageQalaisaB from "../../../assets/img/game/gift/qalaisa-b.png"
import ImageQalaisaL from "../../../assets/img/game/gift/qalaisa-l.png"
import ImageErmengardeB from "../../../assets/img/game/gift/ermengarde-b.png"
import ImageErmengardeL from "../../../assets/img/game/gift/ermengarde-l.png"
import ImageMitmB from "../../../assets/img/game/gift/mitm-b.png"
import ImageMitmL from "../../../assets/img/game/gift/mitm-l.png"
import ImageCrownieB from "../../../assets/img/game/gift/crownie-b.png"
import ImageCrownieL from "../../../assets/img/game/gift/crownie-l.png"
import ImageTinmanB from "../../../assets/img/game/gift/tinman-b.png"
import ImageTinmanL from "../../../assets/img/game/gift/tinman-l.png"
import ImageHraaselsuherB from "../../../assets/img/game/gift/hraaselsuher-b.png"
import ImageHraaselsuherL from "../../../assets/img/game/gift/hraaselsuher-l.png"
import ImageNymphB from "../../../assets/img/game/gift/nymph-b.png"
import ImageNymphL from "../../../assets/img/game/gift/nymph-l.png"
import ImageDefault from "../../../assets/img/game/gift/default.png"

const GAME_GIFT_DICT: Record<string, IGameGift> = {
    "kalts-b": { ...json["kalts-b"], image: ImageKaltsB },
    "kalts-l": { ...json["kalts-l"], image: ImageKaltsL },
    "nymph-b": { ...json["nymph-b"], image: ImageNymphB },
    "nymph-l": { ...json["nymph-l"], image: ImageNymphL },
    "qalaisa-b": { ...json["qalaisa-b"], image: ImageQalaisaB },
    "qalaisa-l": { ...json["qalaisa-l"], image: ImageQalaisaL },
    "ermengarde-b": { ...json["ermengarde-b"], image: ImageErmengardeB },
    "ermengarde-l": { ...json["ermengarde-l"], image: ImageErmengardeL },
    "mitm-b": { ...json["mitm-b"], image: ImageMitmB },
    "mitm-l": { ...json["mitm-l"], image: ImageMitmL },
    "crownie-b": { ...json["crownie-b"], image: ImageCrownieB },
    "crownie-l": { ...json["crownie-l"], image: ImageCrownieL },
    "tinman-b": { ...json["tinman-b"], image: ImageTinmanB },
    "tinman-l": { ...json["tinman-l"], image: ImageTinmanL },
    "hraaselsuher-b": { ...json["hraaselsuher-b"], image: ImageHraaselsuherB },
    "hraaselsuher-l": { ...json["hraaselsuher-l"], image: ImageHraaselsuherL },
    default: { ...json["default"], image: ImageDefault },
}

export default GAME_GIFT_DICT
